"use strict";
var TimerObservable_1 = require('./TimerObservable');
exports.timer = TimerObservable_1.TimerObservable.create;
//# sourceMappingURL=timer.js.map


//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/~/.pnpm/rxjs@5.5.12/~/rxjs/observable/timer.js
// module id = ../../../../../../rxjs@5.5.12/node_modules/rxjs/observable/timer.js
// module chunks = 4